class ResourceFactory
  @$inject: ['$resource', '$timeout', "config"]
  constructor: ($resource, $timeout, config)->
    return (url, params, methods)->
      defaults = 
        update:
          method: "PUT"
          isArray: false
        create:
          method: "POST"
        query:
          method: "GET"
          isArray: true
        paginate:
          method: "GET"
          isArray: true
          transformResponse: (data, header, status)->
            if status > 400
              return null
            result = angular.fromJson(data)
            content = result.docs
            meta =
              page: result.page
              pages: result.pages
              limit: result.limit
              total: result.total
            content.$pagination = meta;
            return content;
          interceptor:
            response: (response)->
              response.resource.$pagination = response.data.$pagination
              return response.resource
      methods = angular.extend(defaults, methods)
      resource = $resource( url, params, methods )     
      resource.prototype.$save = ()->
        if !@id and !@_id
          return @$create()
        else
          return @$update()
      resource.cache = (name)->
        name ?= "cached"
        @cached ?= {}        
        @cached[name] ?= {}
        if not @cached[name]?.$promise      
          params = {}
          if name
            params[name] = true          
          console.log params
          @cached[name].$promise = resource.query(params).$promise
          $timeout ()=>
            @cached[name].$promise = null
          , config.api.cache.timeout
        return @cached[name].$promise      
      return resource;

module.exports = ResourceFactory



// WEBPACK FOOTER //
// ./src/common/resource/restful/resource.coffee